import React from "react";
import "./Rail.css";

function Rail({ side = "left", width, label, className = "", children }) {
    const cssVar = width ? { "--rail-width": `${width}px` } : undefined;
    return (
        <aside
            className={`rail rail--${side} ${className}`}
            style={cssVar}
            aria-label={label || (side === "left" ? "Parameters" : "Telemetry")}
        >
            {children}
        </aside>
    );
}

export default Rail;
